<template>
  <div
    id="modal-chat-message"
    aria-hidden="true"
    aria-labelledby="modalFillInLabel"
    class="modal animation opacity modal-default modal-chat"
    data-backdrop="false"
    role="dialog"
    tabindex="-1"
  >
    <div v-show="status === 'textarea'" class="modal-dialog">
      <div class="chat-window">
        <header v-if="conversation">
          <span v-html="header"></span>

          <button aria-hidden="true" class="close" type="button" @click="close">
            <!-- TODO extract svg -->
            <svg
              height="12"
              viewBox="0 0 10 10"
              width="12"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <path id="qczca" d="M1110 328l8-8" />
                <path id="qczcb" d="M1110 320l8 8" />
              </defs>
              <g>
                <g transform="translate(-1109 -319)">
                  <g>
                    <use
                      fill="#fff"
                      fill-opacity="0"
                      stroke="#676486"
                      stroke-linecap="square"
                      stroke-miterlimit="50"
                      stroke-width="1.5"
                      xlink:href="#qczca"
                    />
                  </g>
                  <g>
                    <use
                      fill="#fff"
                      fill-opacity="0"
                      stroke="#676486"
                      stroke-linecap="square"
                      stroke-miterlimit="50"
                      stroke-width="1.5"
                      xlink:href="#qczcb"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </header>

        <form action="#" @submit.prevent="send">
          <div class="chat-content">
            <span>{{ __('Start typing or') }}</span>
            <a data-origin="widget" data-target="#modal-chat-templates" data-toggle="modal" href="#">
              {{ __('select from template') }}
            </a>
            <textarea id="message" v-model="message" :placeholder="__('Start typing')" onkeyup="auto_grow(this)"></textarea>
          </div>

          <footer>
            <div class="comment-user-input--button">
              <a data-origin="widget" data-target="#modal-chat-templates" data-toggle="modal" href="#">
                <span class="sc-user-input--tooltip">{{ __('Select from template') }}</span>
                <!-- TODO extract svg -->
                <svg
                  aria-hidden="true"
                  class="svg-inline--fa fa-align-left fa-w-14"
                  data-icon="align-left"
                  data-prefix="fas"
                  focusable="false"
                  height="24"
                  role="img"
                  viewBox="0 0 448 512"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                    fill="#b1b1b1"
                  ></path>
                </svg>
              </a>
            </div>
            <div class="comment-user-input--button comment-user-input--button-file">
              <label htmlfor="file-input">
                <button class="comment-user-input--file-icon-wrapper" type="button">
                  <!-- TODO extract svg -->
                  <svg
                    aria-hidden="true"
                    class="svg-inline--fa fa-image fa-w-16"
                    data-icon="image"
                    data-prefix="fas"
                    focusable="false"
                    height="24"
                    role="img"
                    viewBox="0 0 512 512"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                      fill="#b1b1b1"
                    ></path>
                  </svg>
                </button>
                <input id="file-input" type="file" />
              </label>
            </div>
            <div class="comment-user-input--button">
              <EmojiIcon :onEmojiPicked="onEmojiPicked" />
              <!-- <div class="comment-user-input--picker-wrapper">
                    <button class="comment-user-input--emoji-icon-wrapper">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="laugh" width="24" height="24" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" class="comment-user-input--emoji-icon svg-inline--fa fa-laugh fa-w-16"><path fill="#b1b1b1" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"></path></svg>
                    </button>
                </div> -->
            </div>
            <div class="comment-user-input--button">
              <!-- Temporary modal opening -->
              <!-- // data-target="#modal-chat-success" data-dismiss="modal" data-toggle="modal" -->
              <button type="submit" :disabled="message === ''">
                <!-- TODO extract svg -->
                <svg
                  height="42px"
                  version="1.1"
                  viewBox="0 0 35 36"
                  width="42px"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <title>Group 2</title>
                  <desc>Created with Sketch.</desc>
                  <g id="Lympha-stage" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                    <g id="Vitadio_soukromé-zprávy" transform="translate(-1349.000000, -834.000000)">
                      <g id="Group-2" transform="translate(1349.000000, 834.000000)">
                        <g id="send" fill="#5937B7" transform="translate(9.000000, 10.000000)">
                          <path
                            id="Path"
                            d="M18.808889,6.74023189 L2.67240008,0.14676662 C1.9925952,-0.131035178 1.22458717,-0.0088285438 0.668141704,0.465534759 C0.111696234,0.939974994 -0.121038206,1.67098377 0.0608368451,2.37325841 L1.49712631,7.91975479 L8.52939392,7.91975479 C8.85298776,7.91975479 9.11537065,8.17809277 9.11537065,8.49678397 C9.11537065,8.81543671 8.85302682,9.07381316 8.52939392,9.07381316 L1.49712631,9.07381316 L0.0608368451,14.6202711 C-0.121038206,15.3225842 0.111657172,16.053593 0.668141704,16.5279947 C1.22571999,17.0033197 1.99380614,17.1240261 2.67243914,16.8467629 L18.8089281,10.2533361 C19.5436158,9.95314701 19.9999831,9.28006811 19.9999831,8.49678397 C19.9999831,7.71349984 19.5436158,7.04038247 18.808889,6.74023189 Z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
            </div>
          </footer>
        </form>
      </div>
    </div>

    <CloseAlert v-show="status === 'close'" @clearAndClose="onClearAndClose" @status="onStatus" />
    <SuccessAlert v-show="status === 'success'" @clearAndClose="onClearAndClose" @status="onStatus" />
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import EmojiIcon from '../chat/emoji/EmojiIcon.vue'
  import CloseAlert from './CloseAlert.vue'
  import SuccessAlert from './SuccessAlert.vue'

  export default {
    components: {
      EmojiIcon,
      CloseAlert,
      SuccessAlert
    },
    data() {
      return {
        message: '',
        status: 'textarea',
        messageTimeout: -1,
        loaded: true
      }
    },
    computed: {
      ...mapGetters({
        chatWidget: 'chat/chatWidget'
      }),
      conversation() {
        return this.chatWidget.conversation
      },
      header() {
        return `${lang.get('Chat with')} <a href="/patient/user/${this.conversation.id}"><span>${
          this.conversation.name
        }</span></a>`
      }
    },
    watch: {
      'chatWidget.message'(message) {
        if (message) {
          this.message = message
          $('.chat-content').click()
        }
      },
      message(message) {
        clearTimeout(this.messageTimeout)

        this.messageTimeout = setTimeout(() => {
          this.updateChatWidget({ message })

          if (this.loaded) {
            $('#modal-chat-message #message').height($('#modal-chat-message #message')[0].scrollHeight)
            this.loaded = false
          }
        }, 350)

        $('#modal-chat-message #message').height($('#modal-chat-message #message')[0].scrollHeight)
      },
      status(status) {
        if (status == 'success') {
          setTimeout(() => {
            this.onClearAndClose()
          }, 2000)
        }
      }
    },
    mounted() {
      $('.chat-content').click(function() {
        $('.chat-content').addClass('textarea')
        $('.chat-content #message').focus()
      })

      $('#modal-chat-message').on('shown.bs.modal', function(e) {
        $(document).off('focusin.modal');
        $('body').removeClass('modal-open')
      })

      this.loadChatWidget()

      Vuemit.listen('Chat--input-add-message', this.onAddInputMessage)
    },
    beforeDestroy() {
      Vuemit.remove('Chat--input-add-message', this.onAddInputMessage)
    },
    methods: {
      ...mapActions({
        loadChatWidget: 'chat/loadChatWidget',
        sendMessage: 'chat/sendMessage'
      }),
      ...mapMutations({
        updateChatWidget: 'chat/updateChatWidget'
      }),
      close() {
        if (this.message) {
          this.status = 'close'
        } else {
          $('#modal-chat-message').modal('hide')
          $('.chat-content').removeClass('textarea')
          this.updateChatWidget({ open: false })
        }
      },
      onStatus(status) {
        this.status = status
      },
      onClearAndClose() {
        this.status = 'textarea'
        this.message = ''
        this.close()
      },
      onEmojiPicked(emoji) {
        this.message += emoji
      },
      onAddInputMessage({ origin, template }) {
        if (origin !== 'widget') return

        if (!$('.chat-content').hasClass('textarea')) {
          $('.chat-content').click()
        }

        if (this.message && !this.message.endsWith(' ')) {
          this.message += ' '
        }

        this.message += template.body
      },
      send() {
        if (!this.message) {
          return alert(this.__('Message body is required!'))
        }

        this.sendMessage({ body: this.message, channel_id: this.conversation.channel_id, files: [] })

        this.message = ''
        this.status = 'success'
      }
    }
  }
</script>
